import { render, staticRenderFns } from "./AgenciesTable.vue?vue&type=template&id=4f29bf82&"
import script from "./AgenciesTable.vue?vue&type=script&lang=ts&"
export * from "./AgenciesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports